var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M20.148 16.898a.5.5 0 0 0 .494-.423l.674-4.31a.5.5 0 0 0-.494-.577h-3.715V9.29c0-.515.13-.962.406-1.276.265-.302.732-.553 1.57-.553H21a.5.5 0 0 0 .5-.5v-3.67a.5.5 0 0 0-.417-.493L21 3.291l.082-.493h-.006l-.016-.003-.06-.01-.226-.034a26 26 0 0 0-.795-.102 22 22 0 0 0-2.38-.149c-1.835 0-3.407.547-4.523 1.643-1.117 1.097-1.718 2.688-1.718 4.659v2.786H8a.5.5 0 0 0-.5.5v4.31a.5.5 0 0 0 .5.5h3.358v9.92a.5.5 0 0 0 .424.495 16 16 0 0 0 4.901 0 .5.5 0 0 0 .424-.494v-9.921z"
  })));
};
export default SvgFacebook;